<template>
    <div class="panel-content">
        <h2>Tracer Center Amsterdam</h2>
        <img class="header" src="/static/img/overlay-assets/header7-2.jpg" />
        <p>Tracer Center Amsterdam: Voor een beter begrip van ingrijpende ziekten en ziektespecifieke moleculaire en cellulaire doelwitten en gerichte geneesmiddelen met behulp van tracers</p>
        <p>Het Tracer Center Amsterdam (TCA) is een R&D-centrum dat radiofarmaca en optische beeldvormingssondes (ook wel tracers genoemd) ontwikkelt, synthetiseert en onderzoekt. Na dit proces worden ze geproduceerd overeenkomstig goede fabricagepraktijken (GMP). Deze tracers zijn nodig voor multimodale beeldvorming. TCA ontwikkelt onder streng gecontroleerde en steriele laboratoriumomstandigheden medische tracers. De bijzondere nadruk ligt op het radioactief labelen van door innovatieve (inter)nationale KMO's en grote farmaceutische bedrijven ontwikkelde nieuwe geneesmiddelen, om beeldvorming in vroeg-klinische onderzoeken mogelijk te maken. Deze benadering leidt tot selectie van de beste geneesmiddelen en patiënten die het meeste baat bij de behandeling kunnen hebben, en is als zodanig een bijdrage aan de oplossing voor het maatschappelijke probleem van kosteneffectieve ontwikkeling van geneesmiddelen en behandelingen afgestemd op de individuele patiënt.</p>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
